<template>
  <WithAsideCards :data="computedCards" :class="$style.config">
    <div
      :class="[
        $style.imageGallery,
        computedCards?.length && $style.hasAsideCards,
      ]"
    >
      <div :class="$style.inner">
        <div :class="$style.header">
          <BaseHeading size="h2" :class="$style.heading">
            {{ data?.fields?.heading }}
          </BaseHeading>
          <BaseHeading size="h4" :class="$style.subheading">
            {{ data?.fields?.subheading }}
          </BaseHeading>
          <MarkedParser :md="data?.fields?.copy" :class="$style.copy" />
        </div>
        <ImageGalleryCarousel
          v-if="data?.fields?.images?.length"
          :data="data?.fields?.images"
          @open-modal="shouldOpenModal = true"
        />

        <BaseDialog
          :visible="shouldOpenModal"
          :class="$style.dialog"
          @close-dialog="shouldOpenModal = false"
        >
          <div :class="$style.dialogContent">
            <ImageGalleryCarousel
              :is-modal="true"
              :data="data?.fields?.images"
              @open-modal="shouldOpenModal = true"
            />
          </div>
        </BaseDialog>
      </div>
    </div>
  </WithAsideCards>
</template>

<script setup lang="ts">
import type { TypeImageGalleryWithoutUnresolvableLinksResponse } from '~/types/contentful'

const props = defineProps<{
  data: TypeImageGalleryWithoutUnresolvableLinksResponse
}>()

// Data
const shouldOpenModal = ref(false)

// Computed
const computedCards = computed(() =>
  props?.data?.fields?.asideCards?.filter?.(instanceOfAsideCard),
)
</script>

<style lang="scss" module>
.config {
  --copy-width: 100%;
  --max-width: 100%;

  @include media('lg') {
    --copy-width: 60%;
  }
}

.imageGallery {
  min-width: 0;

  &.hasAsideCards {
    --max-width: 1040px;

    @include media('lg') {
      --copy-width: 90%;
    }
  }
}

.inner {
  margin: auto;
  max-width: var(--max-width);
}

.header {
  margin-bottom: 3em;
}

.heading {
  text-align: center;
}

.subheading {
  margin-bottom: 0.25em;
  text-align: center;
}

.copy {
  @include fluid-type(16px, 19px);
  line-height: math.div(30, 19);
  margin: auto;
  text-align: center;
  width: var(--copy-width);

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    @include fluid-type(18px, 25px);
    font-family: var(--roboto-condensed);
    line-height: math.div(30, 25);
    margin-bottom: 0.5em;
  }
}

.dialog {
  height: 100%;
  max-height: 100%;
  max-width: 1300px;
}

.dialogContent {
  height: 100%;
}
</style>
